import { render, staticRenderFns } from "./DetailsResale.vue?vue&type=template&id=00360303&scoped=true"
import script from "./DetailsResale.vue?vue&type=script&lang=js"
export * from "./DetailsResale.vue?vue&type=script&lang=js"
import style0 from "./DetailsResale.vue?vue&type=style&index=0&id=00360303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00360303",
  null
  
)

export default component.exports